import { PlaydateInvite, InviteStatus } from "../../gql/types";
import { TagVariant } from "./InfoTag";

export const inviteStatusTagComputer = (invite: PlaydateInvite): Array<{ label: string; variant: TagVariant }> => {
    const tags: Array<{ label: string; variant: TagVariant }> = [];

    switch (invite.status) {
        case InviteStatus.Confirmed:
            tags.push({
                label: "Finalized",
                variant: TagVariant.CONFIRMED,
            });
            break;
        case InviteStatus.Abandoned:
            tags.push({
                label: "Cancelled",
                variant: TagVariant.DECLINED,
            });
            break;
        case InviteStatus.InPlanning:
            if (invite.expired) {
                tags.push({
                    label: "Expired",
                    variant: TagVariant.EXPIRED,
                });
            } else {
                tags.push({
                    label: "Pending",
                    variant: TagVariant.DEFAULT,
                });
            }
            break;
    }

    return tags;
};
